import { Applications } from '../constants';

/**
 * è½¬æ¢ç§æé¨ç½²æä»¶ç path,æ¾å°å¯¹åºå¤§å°çå¾çå°å
 * æ ¼å¼ä¸º: 5,77b32c3ef2;480-360-png-5,793cdd0cdc;160-160-png-1,7813b3967e
 * @param path æ ¼å¼ä¸º: 5,77b32c3ef2;480-360-png-5,793cdd0cdc;160-160-png-1,7813b3967e
 * @param width 480
 * @param height 360
 * @returns 5,793cdd0cdc
 */
export function formatSeaweedPath(path: string, width: number, height: number) {
    if (!path) {
        return null;
    } else {
        const paths = path.split(';');
        if (width && height && paths.length) {
            let result = paths[0];
            paths.forEach(function(item) {
                const prefix = width + '-' + height + '-png-';
                if (item.indexOf(prefix) === 0) {
                    result = item.replace(prefix, '');
                }
            });
            return result;
        } else {
            return paths[0]; // .split(',').join('/') + ".png";
        }
    }
}

export function isAssistant(name: string) {
    return ['phone'].indexOf(name) >= 0 || Applications[name];
}
